import { CONFIG_SHA, CONFIG_VERSION } from "../config";
import type { tags } from "../tags";

export function tags_fromConfig() {
	return {
		"zeller.build.sha": CONFIG_SHA,
		"zeller.build.version": CONFIG_VERSION,
	} satisfies tags.Tags;
}
